/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
/* eslint-disable quotes */
/* eslint-disable arrow-body-style */
import { Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { classNames } from 'shared/lib/classNames/classNames';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getLocationStep, getLocationName, getWindowWidth } from 'features/StepInfo/modal/selectors/getStepInfo/getStepInfo';
import { stepActions } from 'features/StepInfo';
import { useEffect } from 'react';

import background1 from 'shared/assets/img/pages/baby-location-background-1.png';
import background1_1200 from 'shared/assets/img/pages/baby-location-background-1200_1.png';
import background1_1024 from 'shared/assets/img/pages/baby-location-background-1024_1.png';
import background1_768 from 'shared/assets/img/pages/baby-location-background-768_1.png';
import background1_370 from 'shared/assets/img/pages/baby-location-background-370_1.png';
import backgroundImg5 from 'shared/assets/img/pages/background-370.png';

import { Monologue } from 'widgets/Monologue';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { BackgroundHandler } from 'shared/ui/BackgroundHandler/BackgroundHandler';
import BackIcon from 'shared/assets/icons/backIcon.svg';
import { QUESTIONS } from '../api/questions';

import cls from './MonologuePage.module.scss';

export const MonologuePage = () => {
    // const dispatch = useDispatch();
    // const locationStep = useSelector(getLocationStep);
    // const locationName = useSelector(getLocationName);
    // const windowWidth = useSelector(getWindowWidth);
    // const { age, id } = useParams();

    // const {
    //     primaryText, buttonText, background,
    //     icon, questions, correctAnswer,
    //     signs, title, paragraths, isOver,
    //     changeLogo, video, type,
    // } = QUESTIONS[age][id];

    // const setBackground = () => {
    //     if (Number(id) === 0) {
    //         dispatch(stepActions.setBackground(
    //             {
    //                 1700: `url(${background1})`,
    //                 1200: `url(${background1_1200})`,
    //                 1024: `url(${background1_1024})`,
    //                 768: `url(${background1_768})`,
    //                 370: `url(${background1_370})`,
    //             },
    //         ));
    //     } else {
    //         dispatch(stepActions.setBackground(QUESTIONS[age][Number(id) - 1].background));
    //     }
    // };

    // useEffect(() => {
    //     setBackground();
    //     dispatch(stepActions.setLocationData({ step: id, age }));
    // });

    const name = 'Аня';
    const message = `Привет! Меня зовут Аня, сегодня мне исполняется 14 лет!
    Учусь в школе №1 города Энска, в 9 классе, увлекаюсь вопросами экологии и бережного отношения к окружающей среде.`;

    return (
        <div className={cls.page}>
            <BackgroundHandler />
            <div className={cls.backButton}>
                <Button icon={<BackIcon />} theme={ButtonTheme.BACK}>
                    Главное меню
                </Button>
            </div>
            <Monologue name={name} message={message} />
            <div className={cls.nextButton}>
                <Button theme={ButtonTheme.NEXT}>
                    Далее
                </Button>
            </div>
        </div>
    );
};
